import React, { useRef, useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function Addcategory() {
  const [category, setCategory] = useState("");
  const [existingCategories, setExistingCategories] = useState([]);
  const refForm = useRef();

  useEffect(() => {
    fetchExistingCategories();
  }, []);

  const fetchExistingCategories = async () => {
    try {
      const res = await fetch(
        "https://capobiz-backend.vercel.app/api/auth/getcategory",
        {
          method: "GET",
        }
      );
      const data = await res.json();

      const cleanedCategories = data.map((post) =>
        post.category
          .split(" ")
          .map(
            (word) =>
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ")
      );

      setExistingCategories(cleanedCategories);
    } catch (error) {
      console.error(error);
    }
  };

  const AddCategory = async (e) => {
    e.preventDefault();
    const form = refForm.current;
    const catValue = form.category.value.trim();
    const cate = document.getElementById("category");

    if (!catValue) {
      cate.innerText = "Please enter category";
      return;
    }

    const isCategoryExists = existingCategories.some(
      (existingCategory) =>
        existingCategory.toLowerCase() === catValue.toLowerCase()
    );

    if (isCategoryExists) {
      cate.innerText = "Category already exists";
      return;
    }

    cate.innerText = "";

    try {
      await fetch("https://capobiz-backend.vercel.app/api/auth/category", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ category: catValue }),
      });

      // Sweet Alert Success
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Category has been added successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      setCategory("");
      fetchExistingCategories();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <div>
      <h2 className="pt-5 pb-3 text-center">Create Category</h2>

      <form ref={refForm} className="form-group" onSubmit={AddCategory}>
        <input
          className="form-control"
          style={{ width: "40%" }}
          type="text"
          placeholder="Add Category"
          name="category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />

        <div id="category" style={{ color: "red" }}></div>

        <button className="btn btn-primary mt-3">Add</button>
      </form>
    </div>
  );
}
